import { createRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AssetActionFormComponent, {
  AssetActioFormConfig,
} from "./asset-action-form.component";
import { useParams } from "react-router-dom";
import {
  getAssetByCode,
  getTriggeringZones,
  setTriggeringZone,
} from "../../../../../../store/slices/asset.slice";
import InfoTileContainer from "../../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../../shared-elements/info-tile/info-tile.component";

const TriggeringZoneCommonComponent = () => {
  const formRef = createRef();
  const dispatch = useDispatch();
  const { id } = useParams();

  const assetDetails = useSelector((state: any) => {
    return state.asset.assetDetails;
  });

  const isLoadingAssetDetails = useSelector((state: any) => {
    return state.asset.isLoadingAssetDetails;
  });

  const onSubmitFilter = (formValues: any) => {
    const form: any = formRef.current;
    const { triggerZones } = form.values;
  };

  const onCancelClick = () => {
    const form: any = formRef.current;
    form.resetForm();
  };

  const formInitialValues = {
    triggerZones: "",
  };

  const actionConfig: any = [
    {
      label: "Cancel",
      event: onCancelClick,
      variant: "default",
      className: "mr-1",
    },
    {
      label: "Save",
      event: onSubmitFilter,
      variant: "primary",
    },
  ];

  const refreshActionConfig: any = [
    {
      label: "Refresh",
      event: onCancelClick,
      variant: "default",
    },
  ];

  const formConfig: AssetActioFormConfig = {
    controls: [
      {
        label: "Trigger Zone (?)",
        isGrid: true,
        controlGroup: [
          {
            name: "triggerZones",
            label: "Assign Trigger Zone",
            placeholder: "",
            type: "chips",
            required: true,
          },
        ],
      },
    ],
  };

  useEffect(() => {
    if (!id || Object.keys(assetDetails).length) return;
    dispatch(getAssetByCode({ id }));
    dispatch(getTriggeringZones({ id }));
  }, [id]);

  return (
    <div>
      <div className="asset-details">
        <InfoTileContainer header="Asset Details">
          <InfoTileComponent
            title="Asset ID"
            value={assetDetails.assetId}
            valueWidth={3}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Asset Type"
            value={assetDetails.assetType}
            isLoading={isLoadingAssetDetails}
          />
        </InfoTileContainer>

        <InfoTileContainer header="Location Details">
          <InfoTileComponent
            title="Town Council"
            value={assetDetails.townCouncil}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Site"
            value={assetDetails.site}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Block"
            value={assetDetails.block}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Street"
            value={assetDetails?.street}
            isLoading={isLoadingAssetDetails}
          />
        </InfoTileContainer>
      </div>
      <div className="mt-3">
        <AssetActionFormComponent
          formRef={formRef}
          initialValues={formInitialValues}
          formConfig={formConfig}
          actionConfig={actionConfig}
          refreshActionConfig={refreshActionConfig}
        />
      </div>
    </div>
  );
};

export default TriggeringZoneCommonComponent;
